/**
 * Provides a switch component for the axis preference.
 *
 * @packageDocumentation
 * @module AxisPreferenceSwitch
 * @internal
 */

import { Box, Switch, Typography } from '@mui/material';
import React from 'react';

// -- type definitions --

/**
 * Props for the AxisPreferenceSwitch component.
 */
interface AxisPreferenceSwitchProps {
  checked: boolean;
  onToggle: () => void;
  label: string;
}

// -- component --

/**
 * A generic switch component for the axis preference.
 */
export const AxisPreferenceSwitch: React.FC<AxisPreferenceSwitchProps> = ({
  checked,
  onToggle,
  label,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Typography variant="body2">{label}</Typography>
      <Switch
        checked={checked}
        onChange={onToggle}
        color="primary"
        size="small"
      />
    </Box>
  );
};
